import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import PhotoItems from "./photo_items";
import PhotoUploading from "./photo_uploading";
// import ModalFaceMaskEditor from './modal_face_mask_editor';
import ModalPhotoViewer from "./modal_photo_viewer";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";
import compressImage from "../../lib/image_compressor";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    album: PropTypes.object.isRequired,
    memberId: PropTypes.number.isRequired,
    loadAllFileCapacityFromServer: PropTypes.func.isRequired,
    loadAlbumFileCapacityFromServer: PropTypes.func.isRequired,
    canUploadPrivateStrage: PropTypes.bool.isRequired,
    myMemberType: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      loading: false,
      uploadingPhoto: false,
      photoList: { photos: [] },
      isModalOpen: false,
      modalPhotoIndex: 0,
      modalPhotoUrl: "",
      modalPhotoDir: "photo-w",
      modalPhotoUploadedDate: "",
      isPhotoSaved: false,
      isDeleteMode: false,
      isFaceMaskMode: false,
      scrollPos: 0,
      selectedPhotoId: 0,
    };
  },
  componentDidMount() {
    this.loadAlbumPhotosFromServer();
    window.addEventListener("beforeunload", this.onUnload);
  },
  // 写真の枚数が変わったら（読み込み・追加・削除のあと）、見出しの「⋮」と「編集」の出し分けのために知らせる（見た目のみ）
  componentDidUpdate(prevProps, prevState) {
    // 最後の1枚を消して0枚になったら、削除中の表示も終える（0枚の画面には「完了」が無く、
    // そのまま写真を追加すると新しい写真が削除待ちの見た目で出てしまうため）
    if (
      this.state.isDeleteMode &&
      this.state.isPhotoListLoaded &&
      this.state.photoList.photos.length === 0
    ) {
      this.setState({ isDeleteMode: false });
    }
    if (!this.props.onPhotoCountChange) {
      return;
    }
    if (
      prevState.isPhotoListLoaded !== this.state.isPhotoListLoaded ||
      prevState.photoList.photos.length !== this.state.photoList.photos.length
    ) {
      this.props.onPhotoCountChange(
        this.state.isPhotoListLoaded ? this.state.photoList.photos.length : null
      );
    }
  },
  onUnload(event) {
    if (!this.state.isPhotoSaved) {
      event.returnValue = "";
    }
  },
  SetModalPhotoDirection(url) {
    var img = new Image();
    img.src = url;
    var width = img.width;
    var height = img.height;
    var dispAspectRatio = (window.innerWidth / window.innerHeight).toFixed(2);
    var picAspectRatio = (width / height).toFixed(2);
    var direction =
      dispAspectRatio - picAspectRatio < 0 ? "photo-w" : "photo-h";
    this.setState({
      modalPhotoDir: direction,
    });
  },
  changeDeleteMode() {
    if (!this.state.isDeleteMode) {
      this.setState({
        isFaceMaskMode: false,
      });
    }
    this.setState({
      isDeleteMode: !this.state.isDeleteMode,
    });
  },
  changeFaceMaskMode() {
    if (!this.state.isFaceMaskMode) {
      this.setState({
        isDeleteMode: false,
      });
    }
    this.setState({
      isFaceMaskMode: !this.state.isFaceMaskMode,
    });
  },
  closeModal() {
    $(document.body).css({
      position: "relative",
      marginTop: "0",
      marginLeft: "0",
    });
    $(window).scrollTop(this.state.scrollPos);
    this.setState({
      isModalOpen: false,
    });
  },
  openModal(e) {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $("body .container").outerWidth()) / 2;
    $(document.body).css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
    });
    var url = this.state.photoList.photos[e].safe_image;
    this.SetModalPhotoDirection(url);
    var uploaded_date = this.state.photoList.photos[e].uploaded_date;
    this.setState({
      isModalOpen: true,
      modalPhotoIndex: e,
      modalPhotoUrl: url,
      modalPhotoUploadedDate: uploaded_date,
      scrollPos: scrollPos,
    });
  },
  changePhoto(e) {
    var index = e;
    var photoCount = this.state.photoList.photos.length;
    if (index < 0) {
      index = photoCount - 1;
    } else if (index > photoCount - 1) {
      index = 0;
    }
    var url = this.state.photoList.photos[index].safe_image;
    this.SetModalPhotoDirection(url);
    var uploaded_date = this.state.photoList.photos[index].uploaded_date;
    this.setState({
      modalPhotoIndex: index,
      modalPhotoUrl: url,
      modalPhotoUploadedDate: uploaded_date,
    });
  },
  addPhotoToServer(file) {
    if (!file) {
      return;
    }
    this.setState({
      uploadingPhoto: true,
    });
    var formData = new FormData();
    formData.append("file", file);
    formData.append("album_id", this.props.album.id);
    formData.append("public_type", this.props.album.public_type);
    formData.append("member_id", this.props.memberId);
    formData.append("circle_id", this.props.album.circle_id);
    $.ajax({
      url: "/api/album/add_photo",
      type: "POST",
      dataType: "json",
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: function(data) {
        if (data) {
          this.loadAlbumPhotosFromServer();
          this.props.loadAllFileCapacityFromServer();
          if (this.props.album.public_type == 2) {
            this.props.loadAlbumFileCapacityFromServer();
          }
        } else {
          this.setState({
            uploadingPhoto: false,
          });
          this.modalAlertFileError.openModal();
        }
      }.bind(this),
      error: function() {
        this.setState({
          uploadingPhoto: false,
        });
        this.modalAlertFileError.openModal();
      }.bind(this),
    });
  },
  loadAlbumPhotosFromServer() {
    $.ajax({
      url: "/api/album/get_photos",
      type: "POST",
      dataType: "json",
      data: {
        album_id: this.props.album.id,
      },
      cache: false,
      success: function(data) {
        this.setState({
          loading: false,
          photoList: data,
          uploadingPhoto: false,
          // 写真0枚の表示を、読み込みが終わってから出すための目印（見た目のみ）
          isPhotoListLoaded: true,
          isPhotoSaved: data.photos.length > 0,
        });
      }.bind(this),
      error: function() {
        this.setState({
          uploadingPhoto: false,
        });
      }.bind(this),
    });
  },
  // 「写真を追加」はファイル選択を包んだ label なので、キーボード（Enter / スペース）でも
  // クリックと同じようにファイル選択を開けるようにする
  handleAddKeyDown(e) {
    if (e.key !== "Enter" && e.key !== " ") {
      return;
    }
    e.preventDefault();
    var input = e.currentTarget.querySelector("input[type=file]");
    if (input && !input.disabled) {
      input.click();
    }
  },
  async handleInputFileField(e) {
    var file = e.target.files[0];
    file = await compressImage(file);
    if (this.props.canUploadPrivateStrage) {
      this.addPhotoToServer(file);
    } else if (this.props.album.public_type == 4) {
      this.addPhotoToServer(file);
    } else {
      this.modalAlertStrageOver.openModal();
    }
  },
  deletePhotoFromServer() {
    $.ajax({
      url: "/api/album/delete_photo",
      type: "POST",
      dataType: "json",
      data: {
        photo_id: this.state.selectedPhotoId,
      },
      cache: false,
      success: function(data) {
        if (data) {
          this.loadAlbumPhotosFromServer();
          this.props.loadAlbumFileCapacityFromServer();
          this.props.loadAllFileCapacityFromServer();
        } else {
          this.modalAlertDeleteError.openModal();
        }
      }.bind(this),
      error: function() {
        this.modalAlertNetworkError.openModal();
      }.bind(this),
    });
  },
  deletePhotoSelected(e) {
    this.setState({
      selectedPhotoId: e,
    });
    this.modalConfirmDeletePhoto.openModal();
  },
  faceMaskPhotoSelected(index, photoId) {
    var url = this.state.photoList.photos[index].safe_image;
    this.SetModalPhotoDirection(url);
    this.setState(
      {
        selectedPhotoId: photoId,
        modalPhotoIndex: index,
        modalPhotoUrl: url,
        isFaceMaskMode: false,
      },
      function() {
        this.modalFaceMaskEditor.openFaceMaskEditor();
      }
    );
  },
  deletePhoto() {
    this.deletePhotoFromServer();
  },
  render() {
    var photos = this.state.photoList.photos.map(function(item, index) {
      return (
        <PhotoItems
          index={index}
          photo={item}
          openModal={this.openModal}
          key={item.id}
          isPhotoDeletebuttonActive={this.state.isDeleteMode}
          isFaceMaskButtonActive={this.state.isFaceMaskMode}
          deletePhotoSelected={this.deletePhotoSelected}
          faceMaskPhotoSelected={this.faceMaskPhotoSelected}
        />
      );
    }, this);
    var isPhotoEmpty =
      this.state.isPhotoListLoaded &&
      this.state.photoList.photos.length === 0 &&
      !this.state.uploadingPhoto;
    // 0枚のときの表示は、アルバム一覧の0冊（画面63-1）と同じ作り（アイコン → グレーの文字 → 赤のボタン）
    var photoList = isPhotoEmpty ? (
      <div className="alb-list-empty">
        {/* アルバム一覧（画面63）と同じ、やることリスト（画面36）の形のアイコン */}
        <span className="alb-list-empty__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <path d="m21 15-5-5L5 21" />
          </svg>
        </span>
        <p className="alb-list-empty__title">写真はまだありません</p>
        {this.props.myMemberType === 1 ? (
          <p className="alb-list-empty__text">
            写真を追加して、思い出を共有しよう！
          </p>
        ) : (
          ""
        )}
        {this.props.myMemberType === 1 ? (
          <label
            className="alb-create"
            role="button"
            tabIndex={this.state.uploadingPhoto ? -1 : 0}
            onKeyDown={this.handleAddKeyDown}
          >
            写真を追加する
            <input
              type="file"
              className="form_file_photo"
              style={{ display: "none" }}
              onChange={(e) => this.handleInputFileField(e)}
              disabled={this.state.uploadingPhoto}
            />
          </label>
        ) : (
          ""
        )}
      </div>
    ) : (
      // 写真があるとき（画面62-2）。正方形のタイルを、グレーの面に直接並べる
      <ul
        className={
          "alb-photos" + (this.state.isDeleteMode ? " is-delete-mode" : "")
        }
      >
        <PhotoUploading isActive={this.state.uploadingPhoto} />
        {photos}
      </ul>
    );
    return (
      <div>
        {/* 写真の枚数と、削除の切り替え（画面62-2）。枚数はアルバム一覧のカードと同じマーク＋数字 */}
        {!isPhotoEmpty && this.state.isPhotoListLoaded ? (
          <div className="alb-bar">
            <span className="alb-bar__count">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" /></svg>
              {this.state.photoList.photos.length}
              <span className="alb-card__sr">枚</span>
            </span>
            {this.props.myMemberType === 1 && this.state.isDeleteMode ? (
              // 写真の削除は見出しの「⋮」から始める。削除中だけ、終えるための「完了」を出す
              <button
                type="button"
                className="alb-tool is-active"
                onClick={this.changeDeleteMode}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
                完了
              </button>
            ) : this.props.myMemberType === 1 ? (
              // 写真を追加する。このページの主役なので赤べた塗り（デザイナー案 2026-10-10。
              // 以前は一覧の左上のタイルだった）。中にファイル選択を持つ label
              <label
                className={
                  "alb-addbtn" +
                  (this.state.uploadingPhoto ? " is-disabled" : "")
                }
                role="button"
                tabIndex={this.state.uploadingPhoto ? -1 : 0}
                aria-disabled={this.state.uploadingPhoto}
                onKeyDown={this.handleAddKeyDown}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
                写真を追加
                <input
                  type="file"
                  className="form_file_photo"
                  style={{ display: "none" }}
                  onChange={(e) => this.handleInputFileField(e)}
                  disabled={this.state.uploadingPhoto}
                />
              </label>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {this.props.myMemberType === 1 &&
        !isPhotoEmpty &&
        this.state.isDeleteMode ? (
          <p className="alb-bar__hint">
            削除したい写真の右上の × を押してください
          </p>
        ) : (
          ""
        )}
        <ModalPhotoViewer
          isOpen={this.state.isModalOpen}
          onClose={this.closeModal}
          onChange={this.changePhoto}
          photoIndex={this.state.modalPhotoIndex}
          photoUrl={this.state.modalPhotoUrl}
          photoDir={this.state.modalPhotoDir}
          photoUploadedDate={this.state.modalPhotoUploadedDate}
        />
        {photoList}
        <ModalConfirm
          ref={(c) => {
            this.modalConfirmDeletePhoto = c;
          }}
          title="画像の削除"
          content="元に戻すことはできません。よろしいですか？"
          approveFunc={this.deletePhoto}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertFileError = c;
          }}
          title="ファイルエラー"
          content="選択したファイルが画像ファイルであることを確認してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertDeleteError = c;
          }}
          title="エラー"
          content="時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertNetworkError = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。ネットワークの接続を確認し、もう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStrageOver = c;
          }}
          title="容量制限"
          content="プライベートストレージの制限を超えています。画像を投稿するには、アルバムの公開範囲を「公開」に設定するか、他の画像を削除してください。有料プランに加入するとプライベートストレージの制限を解除できます。"
        />
      </div>
    );
  },
});
